var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 26,
    fill: "none",
    viewBox: "0 0 11 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4141",
    d: "M5.60156 25.75C6.09375 25.75 6.9375 23.7344 6.9375 20.8164V9.625C8.96484 9.05078 10.4414 7.16406 10.4414 4.96094C10.4414 2.27734 8.28516 0.0976562 5.60156 0.0976562C2.90625 0.0976562 0.75 2.27734 0.75 4.96094C0.75 7.16406 2.21484 9.03906 4.24219 9.625V20.8164C4.24219 23.7227 5.09766 25.75 5.60156 25.75ZM4.21875 5.24219C3.33984 5.24219 2.56641 4.45703 2.56641 3.56641C2.56641 2.66406 3.33984 1.91406 4.21875 1.91406C5.13281 1.91406 5.87109 2.66406 5.87109 3.56641C5.87109 4.45703 5.13281 5.24219 4.21875 5.24219Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.d766f15ae6266bac563bf8f91d5d0f14.svg";
export { ForwardRef as ReactComponent };